import React from 'react';
import { Users, FileText, Download, Star } from 'lucide-react';
export function SocialProofBar() {
  return <div className="bg-brand-card text-white py-3 md:py-4 px-3 border-b border-brand-accent/30" data-id="element-209">
      <div className="max-w-3xl mx-auto grid grid-cols-4 gap-2 md:gap-4" data-id="element-210">
        <div className="flex flex-col items-center text-center" data-id="element-211">
          <Users className="w-4 h-4 md:w-6 md:h-6 mb-1 text-brand-accent" data-id="element-212" />
          <span className="text-sm md:text-lg font-black text-white" data-id="element-213">
            +2.500
          </span>
          <span className="text-[9px] md:text-xs text-gray-400 font-bold uppercase tracking-wider" data-id="element-214">
            Herreros
          </span>
        </div>
        <div className="flex flex-col items-center text-center" data-id="element-215">
          <FileText className="w-4 h-4 md:w-6 md:h-6 mb-1 text-brand-accent" data-id="element-216" />
          <span className="text-sm md:text-lg font-black text-white" data-id="element-217">+100</span>
          <span className="text-[9px] md:text-xs text-gray-400 font-bold uppercase tracking-wider" data-id="element-218">
            Planos
          </span>
        </div>
        <div className="flex flex-col items-center text-center" data-id="element-219">
          <Download className="w-4 h-4 md:w-6 md:h-6 mb-1 text-brand-accent" data-id="element-220" />
          <span className="text-sm md:text-lg font-black text-white" data-id="element-221">PDF</span>
          <span className="text-[9px] md:text-xs text-gray-400 font-bold uppercase tracking-wider" data-id="element-222">
            Inmediato
          </span>
        </div>
        <div className="flex flex-col items-center text-center" data-id="element-223">
          <div className="flex mb-1" data-id="element-224">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 md:w-4 md:h-4 text-brand-accent fill-current" data-id="element-225" />)}
          </div>
          <span className="text-sm md:text-lg font-black text-white" data-id="element-226">
            4.9/5
          </span>
          <span className="text-[9px] md:text-xs text-gray-400 font-bold uppercase tracking-wider" data-id="element-227">
            Rating
          </span>
        </div>
      </div>
    </div>;
}